import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { ContactsApi, GroupSummary, GroupsApi, PagedContactResponse } from 'src/app/hickory-api';
import { DirectoryGroup } from 'src/app/shared/directory/base/models';


export interface GroupDetailsData  {
  groupId?: number;
  summary?: GroupSummary;
  title?: string;
}

@Component({
  selector: 'app-group-details-dialog',
  templateUrl: './group-details-dialog.component.html',
  styleUrls: ['./group-details-dialog.component.scss'],
  standalone: false
})
export class GroupDetailsDialogComponent implements OnInit {
  group: DirectoryGroup;

  dialogTitle: string;
  loadError: string = null;
  hideRetry: boolean = false;
  contacts: PagedContactResponse;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GroupDetailsData,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private groupsApi: GroupsApi,
    private contactsApi: ContactsApi,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.dialogTitle = this.data.title ?? this.dialogTitle;
    this.loadGroup();
  }

  loadGroup() {
    const groupId = this.data?.groupId ?? this.data?.summary?.id;
    if (!!this.group || !groupId) return;
    this.loadError = null;
    this.hideRetry = false;
    this.groupsApi.getGroupsByIdV21(groupId).subscribe({
      next: (res) => {
        if (res?.item) {
          this.group = DirectoryGroup.fromHickoryFull(res?.item, false);
          if (this.group.children) {
            this.loadContacts();
          }
        } else {
          this.onDetailsNotFound();
        }
      },
      error: (err) => {
        this.loadError = 'An error occurred retrieving group details';
        if (err.status === 404) {
          this.onDetailsNotFound();
        } 
      }
    });
  }

  private onDetailsNotFound() {
    this.loadError = 'No details found for this group';
    this.hideRetry = true;
  }

  loadContacts() {
    const groupId = this.data?.groupId ?? this.data?.summary?.id;
    if (!groupId) return;
    this.contactsApi.findContacts({ groupId: groupId, includeNestedGroups: true, includeAsset: false, page: 1, pageSize: 1 }).subscribe({
      next: (res) => {
        this.contacts = res;
      },
      error: (_err) => { }
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }
}
